<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">

  <path d="m11.72559,7.30078L5.66992,1.24609c-.38672-.38672-1.01172-.38672-1.39844,0-.38672.38574-.38672,1.0127,0,1.39844l5.35632,5.35547-5.35632,5.35547c-.38672.38574-.38672,1.0127,0,1.39844.19336.19336.44629.29004.69922.29004s.50586-.09668.69922-.29004l6.05566-6.05469c.38672-.38574.38672-1.0127,0-1.39844Z" fill="var(--iconPrimary, #222)"/>

</svg>